// extracted by mini-css-extract-plugin
module.exports = {"notfound":"style_notfound__2A128","logo":"style_logo__l0LmD","errorCode":"style_errorCode__1tpZ9","errorMessage":"style_errorMessage__CG46L"};